import type { ComponentProps } from 'react';
import Link from 'next/link';

import { TeamAvatar, TeamUserAvatar } from '@poseidon/components/Avatar';
import { cn } from '@poseidon/components/cn';
import { useTooltipAnchor, TooltipContent } from '@poseidon/components/Input2/Tooltip';

import { dataOnboardingIds } from '~/components/Onboarding/onboarding.model';

interface UserLogoutRowProps {
  authData: NonNullable<ComponentProps<typeof TeamUserAvatar>['userTeam']> & {
    teamName: string;
    teamLogo: ComponentProps<typeof TeamAvatar>['logo'];
  };
  minimized?: boolean;
}
export const UserLogoutRow = ({ authData, minimized }: UserLogoutRowProps) => {
  const name = authData.userTeamName ?? authData.userEmail;
  const tooltip = minimized ? `${name} (${authData.teamName})` : undefined;
  const { anchorName, anchorStyle, popoverRef, hoverHandlers } = useTooltipAnchor(tooltip);

  return (
    <div className="whitespace-pre flex flex-row items-center gap-1 overflow-hidden pt-6">
      <Link
        className={cn(
          'relative flex shrink grow basis-0 cursor-pointer flex-row gap-3 rounded-md p-2 transition-colors hover:bg-gray-100 dark:hover:bg-slate-900',
        )}
        style={anchorStyle}
        href={`/teams/active/user`}
        data-onboarding={dataOnboardingIds.settingsTrigger}
        {...hoverHandlers}>
        <TeamUserAvatar className="size-10" shape="circle" userTeam={authData} />

        <TeamAvatar
          className="absolute bottom-1 left-1 size-5"
          logo={authData.teamLogo}
          name={authData.teamName}
          shape="circle"
        />
        <div className="flex w-0 shrink grow basis-0 flex-col overflow-hidden text-ellipsis">
          <div className="max-h-5 overflow-hidden text-ellipsis text-sm font-semibold text-gray-700 dark:text-white">
            {name}
          </div>
          <div className="max-h-5 overflow-hidden text-ellipsis text-sm font-normal text-gray-500 dark:text-gray-400">
            {authData.teamName}
          </div>
        </div>
        <TooltipContent anchorName={anchorName} popoverRef={popoverRef}>
          {tooltip}
        </TooltipContent>
      </Link>
    </div>
  );
};
